import { useEffect } from "react";
import { useSeo } from "@/utils/seo";
import { useLang } from "@/i18n";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Leistungen from "@/components/Leistungen";
import HeadendConfigurator from "@/components/HeadendConfigurator";
import ProductBento from "@/components/ProductBento";
import RepairService from "@/components/RepairService";
import TargetSplit from "@/components/TargetSplit";
import Download from "@/components/Download";
import DealerLogin from "@/components/DealerLogin";
import Contact from "@/components/Contact";

export default function Landing() {
    const { t } = useLang();
    useSeo(
        t("Kopfstationen & SAT-ZF-Verteiltechnik | Müller Hemhofen", "Headends & SAT-IF distribution | Müller Hemhofen"),
        t(
            "Müller Satelliten- und Antennentechnik GmbH, Hemhofen: Hersteller eigener Kabelkopfstationen, SAT-ZF-Verteiltechnik, Antennenheizungen und 48h-Reparaturservice für Grundig-Kopfstationen.",
            "Müller Satelliten- und Antennentechnik GmbH, Hemhofen: manufacturer of our own cable headends, SAT-IF distribution, antenna heating and a 48h repair service for Grundig headends."
        ),
    );
    useEffect(() => {
        let target = null;
        try {
            target = sessionStorage.getItem("scroll_to");
        } catch {
            target = null;
        }
        if (!target) return;
        const timer = setTimeout(() => {
            const el = document.querySelector(`#${target}`);
            const y = el ? Math.max(0, el.getBoundingClientRect().top + window.scrollY - 80) : -1;
            try {
                sessionStorage.removeItem("scroll_to");
            } catch {
                /* ignore */
            }
            if (!el) return;
            if (window.__lenis) {
                window.__lenis.resize();
                window.__lenis.scrollTo(y, { duration: 1.2 });
            } else window.scrollTo({ top: y, behavior: "smooth" });
        }, 150);
        return () => clearTimeout(timer);
    }, []);

    return (
        <main>
            <Hero />
            <Marquee />
            <Leistungen />
            <HeadendConfigurator />
            <ProductBento />
            <RepairService />
            <TargetSplit />
            <Download />
            <DealerLogin />
            <Contact />
        </main>
    );
}
